import React from 'react';

const getNonEmpty = (value: unknown, fallback = '-') => {
  if (value === null || value === undefined) return fallback;
  const text = String(value).trim();
  return text.length ? text : fallback;
};

const getInitials = (value: unknown) => {
  const text = getNonEmpty(value, '').trim();
  if (!text) return '--';

  const words = text.split(/\s+/).filter(Boolean);
  if (!words.length) return '--';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();

  return `${words[0][0] ?? ''}${words[1][0] ?? ''}`.toUpperCase();
};

export const ContactsTabContent: React.FC<{ contactRows: any[] }> = ({
  contactRows,
}) => {
  const avatarThemes = [
    'company-details-screen__avatar--lavender',
    'company-details-screen__avatar--sky',
    'company-details-screen__avatar--sage',
    'company-details-screen__avatar--peach',
  ];

  return (
    <div className="company-details-screen__tab-content">
      <div className="company-details-screen__section-title font-semibold">
        Contacts
      </div>
      <div className="company-details-screen__contacts-list">
        {contactRows.length ? (
          contactRows.map((member: any, idx: number) => (
            <div
              key={member?.id ?? `${member?.mobile}-${idx}`}
              className="company-details-screen__contact-card"
            >
              <div
                className={`company-details-screen__avatar ${avatarThemes[idx % avatarThemes.length]}`}
              >
                <span className="company-details-screen__avatar-text font-regular">
                  {getInitials(member?.name)}
                </span>
              </div>
              <div className="company-details-screen__contact-meta">
                <div className="company-details-screen__contact-name font-semibold">
                  {getNonEmpty(member?.name)}
                </div>
                <div className="company-details-screen__contact-mobile font-regular">
                  {getNonEmpty(member?.mobile)}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="company-details-screen__empty font-regular">
            No contact data found.
          </div>
        )}
      </div>
    </div>
  );
};
